import { HFlow, Icon, Tag, Text, Tooltip, useTheme, VFlow } from 'bold-ui'
import { css } from 'emotion'
import React from 'react'

import { Problema, situacaoProblemaRecord } from '../../types/ProblemaModel'

interface ProblemasListCardProps {
  problemas: Problema[]
}

export const ProblemasListCard = (props: ProblemasListCardProps) => {
  const theme = useTheme()
  return (
    <VFlow vSpacing={0.5}>
      {props.problemas.map(({ id, ciap, cid10, descricaoOutro, situacao, avaliadoAgora }) => {
        const situacaoProblema = situacaoProblemaRecord[situacao]

        return (
          <HFlow hSpacing={0.5} alignItems='flex-start' key={id}>
            <Tag
              style={css`
                color: ${situacaoProblema.color};
                background: ${situacaoProblema.background};
              `}
            >
              {situacaoProblema.sigla}
            </Tag>

            <Text component='p'>
              {ciap && `${ciap.descricao.truncate(50)} (${ciap.codigo})`}
              {cid10 && `${separator(ciap)} ${cid10.nome.truncate(50)} (${cid10.codigo})`}
              {descricaoOutro && `${separator(cid10 || ciap)} ${descricaoOutro.truncate(50)}`}
            </Text>

            {avaliadoAgora && (
              <Tooltip text='Alterado agora'>
                <Icon
                  style={css`
                    margin-top: 0.2rem;
                  `}
                  icon='clockOutline'
                  color={theme.pallete.primary.c40}
                  size={1}
                />
              </Tooltip>
            )}
          </HFlow>
        )
      })}
    </VFlow>
  )
}

const separator = (expression: any): string => (expression ? ' | ' : '')
